
import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import { Icon } from "@iconify/react";
import { useTranslation, Trans } from "react-i18next";
import makePhoneNumber from "@/Helpers/makePhoneNumber";
import FrontText from "../../FrontText";
import WebpImage from "../WebpImage";
import { useEffect, useState } from "react";

const AcfAgent = ({ agent }) => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.resolvedLanguage;

    const [fetchedAgent, setFetchedAgent] = useState(null);

    useEffect(() => {
        const fetchAgent = async () => {
            const data = await axios.get(route('front.news.fetchAgent', { email: agent }));

            if (data.status === 200) {
                setFetchedAgent(data.data);
            }
        }

        fetchAgent();
    }, []);

    if (!fetchedAgent) {
        return;
    }

    return (
        <Column xl={8} lg={8} md={10} className={`my-10 mx-auto`}>
            <Row>
                <Column xl={8} lg={10} md={10}>
                    <div className="flex max-w-full h-full shadow-28px rounded-20">
                        <div className="image-wrapper md:w-50 w-32 min-w-[120px] h-full sm:shrink-0">
                            <WebpImage
                                lazy={true}
                                className="w-full h-full rounded-l-20 object-cover"
                                sources={[
                                    {
                                        width: 1,
                                        path: `/storage/avatars/${fetchedAgent.photo.substring(0, fetchedAgent.photo.lastIndexOf('.'))}-400`,
                                        mime: fetchedAgent.photo.split('.').pop(),
                                    },
                                ]}
                                alt={fetchedAgent.name + ' - ' + (currentLang === 'pl' ? fetchedAgent.position : fetchedAgent.position_en)}
                                fallback={`/storage/avatars/${fetchedAgent.photo}`}
                                seo={{
                                    width: 200,
                                    height: 200,
                                }}
                            />
                        </div>

                        <div className="content-wrapper md:py-6 py-3 md:px-5 px-2 bg-dark-blue-standard w-full max-w-full h-full rounded-r-20">
                            <FrontText
                                textSize={"20/29-m-14/20"}
                                className="text-white font-bold"
                            >
                                {fetchedAgent.name}
                            </FrontText>
                            <FrontText
                                textSize={"14/20-m-8/12"}
                                className="text-yellow font-medium"
                            >
                                {currentLang === 'pl' && fetchedAgent.position}
                                {currentLang === 'en' && fetchedAgent.position_en}
                            </FrontText>

                            <div className="mt-c22 text-white">
                                <a
                                    href={`mailto:${fetchedAgent.email}?bcc=marketingleads@savills.pl`}
                                    className="mb-3 hover:text-yellow hover:border-yellow items-center transition-all ease-in-out duration-300 flex gap-c6"
                                >
                                    <Icon
                                        className="shrink-0 p-1 border sm:w-7 sm:h-7 w-6 h-6 border-inherit rounded-full"
                                        icon="material-symbols:mail-outline-rounded"
                                        height={28}
                                        width={28}
                                    />
                                    <FrontText textSize="14/20-m-10/14">
                                        <span className="overflow-wrap-anywhere">
                                            {fetchedAgent.email}
                                        </span>
                                    </FrontText>
                                </a>

                                <a
                                    href={makePhoneNumber(fetchedAgent.phone)}
                                    className="mb-3 hover:text-yellow hover:border-yellow items-center transition-all ease-in-out duration-300 flex gap-c6"
                                >
                                    <Icon
                                        className="shrink-0 p-1 border sm:w-7 sm:h-7 w-6 h-6 border-inherit rounded-full"
                                        icon="ic:baseline-phone"
                                        height={28}
                                        width={28}
                                    />
                                    <FrontText textSize="14/20-m-10/14">
                                        {fetchedAgent.phone}
                                    </FrontText>
                                </a>
                            </div>
                        </div>
                    </div>
                </Column>
            </Row>
        </Column>
    )
}

export default AcfAgent;